import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs';
import { API_MAP } from '../../../core/helpers/api.map';
import { DoctorSelectionService } from './doctor-selection.service';
import { removeQueryParams } from 'app/shared/components/select/helper-functions';

export const DoctorSelectionResolver: ResolveFn<boolean> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  return inject(DoctorSelectionService)
    .get(API_MAP.doctorSelection + removeQueryParams(state.url).substring(1))
    .pipe(map(() => true));
};
